globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PencilModifyIcon = function PencilModifyIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_4652_34786)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M8.3675 14.9039L16.9342 6.33727C17.585 5.68643 17.585 4.63143 16.9342 3.9806L15.9992 3.04477C15.3483 2.39393 14.2933 2.39393 13.6425 3.04477L5.075 11.6123C4.95334 11.7339 4.85167 11.8739 4.7725 12.0264L2.58084 16.2731C2.20917 16.9939 2.98167 17.7673 3.7025 17.3964L7.95167 15.2081C8.10584 15.1281 8.24584 15.0264 8.3675 14.9039Z",
        stroke: "#693EB5",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.92578 11.8242L8.15911 15.0576",
        stroke: "#693EB5",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.0005 17.5H3.36719",
        stroke: "#693EB5",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_4652_34786",
        children: /*#__PURE__*/_jsx("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      })
    })]
  });
};